import React from 'react';

import { FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';

import {
  CustomFormControl,
  CustomLabel,
  CustomHorizontalSpacer,
} from './styles';

export function MainImageSizingSelector({ value, onChange }) {
  return (
    <CustomFormControl>
      <FormLabel id="image_sizing_selector_label" sx={{ fontSize: '12px' }}>
        Modo de preenchimento do fundo de tela
      </FormLabel>
      <RadioGroup
        row
        aria-labelledby="image_sizing_selector_label"
        name="controlled-image_sizing_selector_label_group"
        value={value}
        onChange={onChange}
      >
        <FormControlLabel
          value="contain"
          control={<Radio size="small" />}
          labelPlacement="start"
          label={<CustomLabel>Ajustar</CustomLabel>}
        />
        <CustomHorizontalSpacer />
        <FormControlLabel
          value="cover"
          control={<Radio size="small" />}
          label={<CustomLabel>Preencher</CustomLabel>}
        />
      </RadioGroup>
    </CustomFormControl>
  );
}
